import './App.css';
import AppRoutes from './routes/AppRoutes';

function App() {

// Hola! Por acá dejo otro comentario en el inicio de la App :-)
// Te aconsejo que mantengas tus archivos en carpetas que te sean útiles y no quede todo dando vuelta por donde sea.
// Hoy en día tenemos:
// assets || componentes (componentes reutilizables en toda la app) || constants || hooks (nuestros custom hooks!)
// layouts || pages (una carpeta/archivo por vista que yo tenga... y dentro un components con sus componentes únicos)
// routes || services (todo lo relacionado a las APIS y su llamado)

    return (
        <div className="app-container">
            <AppRoutes />
        </div>
    );
}

export default App;